// File: frontend/src/pages/BlogPostPage.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { client } from '../contentfulClient';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types'; 
import './BlogPostPage.css';

const BlogPostPage = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client.getEntries({
      'content_type': 'post',
      'fields.slug': slug,
      limit: 1
    })
    .then((response) => {
      if (response.items.length > 0) {
        setPost(response.items[0]);
      }
      setLoading(false);
    })
    .catch((error) => {
      console.error("Error fetching post:", error);
      setLoading(false);
    });
  }, [slug]);

  if (loading) {
    return (
      <div className="blog-post-container">
        <h2>Loading Post...</h2>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="blog-post-container">
        <h2>Post not found.</h2>
      </div>
    );
  }

  // --- Rendering Options for Embedded Assets ---
  const renderOptions = {
    renderNode: {
      [BLOCKS.EMBEDDED_ASSET]: (node) => {
        const { file, title, description } = node.data.target.fields;
        const imageUrl = file.url;
        
        return (
          <div className="blog-embedded-image-container">
            <img 
              src={imageUrl} 
              alt={description || title || "Blog image"} 
              className="blog-embedded-image"
            />
            {description && <p className="blog-image-caption">{description}</p>}
          </div>
        );
      }
    }
  };

  const { title, featuredImage, content } = post.fields;

  return (
    <div className="blog-post-container">
      <h1 className="blog-post-title">{title}</h1>
      
      {featuredImage && (
        <img 
          className="blog-post-image"
          src={featuredImage.fields.file.url}
          alt={featuredImage.fields.description || title}
        />
      )}

      <div className="blog-post-content">
        {documentToReactComponents(content, renderOptions)}
      </div>
    </div>
  );
};

export default BlogPostPage;